import { render } from "./CreateEditSchedule.vue?vue&type=template&id=2ae6d738"
import script from "./CreateEditSchedule.vue?vue&type=script&lang=js"
export * from "./CreateEditSchedule.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__